import { Feeling, Photo } from "../../svg";

export default function AddToYourPost({
  setShowPrev,
  onFeelingActivityClick,
  onTagClick,
  onLocationClick,
}) {
  return (
    <div className="addtoyourpost">
      <div className="addto_text">Add to your publication</div>
      <div className="addto_actions">
        <button
          type="button"
          className="addto_action_btn"
          onClick={() => setShowPrev(true)}
        >
          <span className="addto_action_icon photo">
            <Photo color="#45bd62" />
          </span>
          <span className="addto_action_label">Photo / Video</span>
        </button>

        <button
          type="button"
          className="addto_action_btn"
          onClick={onTagClick}
        >
          <span className="addto_action_icon tag">
            <i className="tag_icon"></i>
          </span>
          <span className="addto_action_label">Tag People</span>
        </button>

        <button
          type="button"
          className="addto_action_btn"
          onClick={onFeelingActivityClick}
          title="Feeling/Activity"
        >
          <span className="addto_action_icon feeling">
            <Feeling color="#f7b928" />
          </span>
          <span className="addto_action_label">Feeling / Activity</span>
        </button>

        <button
          type="button"
          className="addto_action_btn"
          onClick={onLocationClick}
        >
          <span className="addto_action_icon location">
            <i className="maps_icon"></i>
          </span>
          <span className="addto_action_label">Check In</span>
        </button>
      </div>
    </div>
  );
}
